import React from 'react';
import { Box, Stack, Typography, CircularProgress, Link } from '@mui/material';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListItem } from 'website/components/JobAdsSectionListItem';
import { IconWrapper } from 'components/Icon';
import { useGetRelatedJobAdsBySlug } from '../api/getRelatedJobAdsBySlug';

export const RecentJobAds = ({ slug }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { data, isLoading, isError, error } = useGetRelatedJobAdsBySlug(slug, {
    page: 0,
    limit: 2, // Fetching 2 recent job ads
    queryOptions: {
      enabled: !!slug,
    },
  });

  const jobAds = data?.jobAds;
  const seeAllLink = `${location.pathname}?tab=job_ads`; // Assuming 'job_ads' is the tab name

  // Only render the section if:
  // 1. slug is present
  // 2. Not in an error state
  // 3. Not currently loading AND there are no job ads OR currently loading BUT there are already some job ads to show.
  if (!slug || isError || (!isLoading && (!jobAds || jobAds.length === 0))) {
    return null;
  }

  return (
    <Box
      sx={{
        p: 3,
        border: '1px solid',
        borderRadius: '8px',
        backgroundColor: 'background.paper',
        borderColor: 'grey.100'
      }}
    >
      {isLoading && <CircularProgress size={20} sx={{ ml: 1 }} />}
      <Stack spacing={2}>
        {jobAds && jobAds.map(jobAd => ( // Only map if jobAds exist
          <ListItem key={jobAd.ad_id} {...jobAd} forcePublicUrls={false} />
        ))}
        <Box>
          <Link
            component={RouterLink}
            to={seeAllLink}
            color="primary.light"
          >
            <Stack sx={{justifyContent: "flex-end", flexDirection: "row", gap: 1}}>
              <Typography>{t('website:publicProfile.seeAll')}</Typography>
              <IconWrapper
                icon="arrowRightLong"
                sx={({ palette }) => ({
                  svg: {
                    color: palette.primary.light,
                    stroke: palette.primary.light,
                    width: 20,
                    height: 20,
                  },
                })}
              />
            </Stack>
          </Link>
        </Box>
      </Stack>
    </Box>
  );
};
